









































































































import { computed, defineComponent, watch } from '@vue/composition-api';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import FileInput from '@front-app/components/inputs/FileInput.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import UserLink from '@front-app/components/buttons/UserLink.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { GroupAccessCodesRequest, AccessCodeStatus } from '@front-app/services/GroupsApi/GroupAccessSettingsModel';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useGroupAccessStore } from '@front-app/store/piniaModules/groupAccess';
import { Size } from '@front-app/components/constants';

export default defineComponent({
	components: {
		CtaButton,
		ErrorCard,
		FileInput,
		LoaderState,
		UserLink,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props, ctx) {
		const isAccessCodesSettingEnabled = computed(() => {
			const group = GroupsStore.getInstance().groupById(props.groupId);
			return group.accessSettings?.enableAccessCodes;
		});

		const groupAccessStore = useGroupAccessStore();
		const accessCodes = computed(() => groupAccessStore.getAccessCodes());

		// Fetching access codes
		const {
			track: trackFetchingAccessCodes,
			isError: isErrorFetchingAccessCodes,
			isLoading: isFetchingAccessCodes,
		} = useAsyncStatus();
		watch(() => props.groupId, (groupId) => trackFetchingAccessCodes(groupAccessStore.fetchGroupAccessCodes(groupId)), { immediate: true });

		// Uploading access codes
		const {
			track: trackUploadingAccessCodes,
			isSuccess: isSuccessUploadingAccessCodes,
			isError: isErrorUploadingAccessCodes,
			isLoading: isUploadingAccessCodes,
		} = useAsyncStatus();

		const uploadAccessCodes = async (files: File[]) => {
			const reader = new FileReader();

			reader.readAsText(files[0]);

			reader.onload = async (e) => {
				const CSVAsText = e.target?.result;
				if (!CSVAsText || typeof CSVAsText !== 'string') {
					throw new Error('Could not read CSV file');
				}

				const CSVAsArray: string[] = CSVAsText.trim().split('\n');
				const formattedCSVArray: string[] = CSVAsArray.map((code: string) => {
					// Remove line breaks from the uploaded codes if there are any
					const formattedCode = code.replace(/(\r\n|\n|\r)/gm, '');
					if (formattedCode.length > 10) {
						return formattedCode.substring(0, 10);
					}
					return formattedCode;
				});

				const payload: GroupAccessCodesRequest = {
					accessCodes: formattedCSVArray,
				};

				await trackUploadingAccessCodes(groupAccessStore.uploadGroupAccessCodes(props.groupId, payload));

				if (isSuccessUploadingAccessCodes.value) {
					ctx.emit('upload-codes');
				}
			};
		};

		return {
			isAccessCodesSettingEnabled,
			accessCodes,
			AccessCodeStatus,
			// Fetching access codes
			isErrorFetchingAccessCodes,
			isFetchingAccessCodes,
			// Uploading access codes
			isErrorUploadingAccessCodes,
			isUploadingAccessCodes,
			uploadAccessCodes,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
